/* ============================================
 BYTE.JS - Main JavaScript File
 All custom JavaScript consolidated here
 ============================================ */

 if (!customElements.get('byte-custom-text-input')) {
    class ByteCustomTextInput extends HTMLElement {
      constructor() {
        super();
        this.charLimit = parseInt(this.dataset.charLimit, 10) || 0;
        this.uppercase = this.dataset.uppercase === 'true';
        this.input = null;
        this.counter = null;
      }
  
      connectedCallback() {
        this.input = this.querySelector('[data-custom-text-input]');
        this.counter = this.querySelector('[data-char-count]');
  
        if (this.input && this.counter) {
          this.#setupEventListeners();
          this.#updateCounter();
        }
      }
  
      disconnectedCallback() {
        if (this.input) {
          this.input.removeEventListener('input', this.boundHandleInput);
        }
      }
  
      #setupEventListeners() {
        this.boundHandleInput = this.#handleInput.bind(this);
        this.input.addEventListener('input', this.boundHandleInput);
      }
  
      #handleInput(e) {
        let value = e.target.value;
  
        if (this.uppercase) {
          value = value.toUpperCase();
          e.target.value = value;
        }
  
        this.#updateCounter();
      }
  
      #updateCounter() {
        if (this.counter && this.input) {
          const remaining = this.charLimit - this.input.value.length;
          this.counter.textContent = remaining;
          this.counter.parentElement.classList.toggle('is-warning', remaining <= 3);
          this.counter.parentElement.classList.toggle('is-error', remaining < 0);
        }
      }
    }
  
    customElements.define('byte-custom-text-input', ByteCustomTextInput);
  }
  
  /* ============================================
 PDP Member discount – price & button update
 Tema buton metnini 1–2 sn sonra ezdiği için hem variant change hem
 sayfa yükleme sonrası gecikmeyle butonu tekrar güncelliyoruz.
 ============================================ */
function applyMemberDiscountPDP(container, variant) {
  if (!container || !window.ByteMemberDiscount) return;

  const percent = window.ByteMemberDiscount.discountPercent;
  const variantPrices = window.ByteMemberDiscount.variantPrices;
  if (!percent || !variantPrices) return;

  let priceInCents = null;
  if (variant && typeof variant.price === 'number') {
    priceInCents = variant.price;
  } else {
    const variantIdInput = container.querySelector('input[name="id"]');
    const variantId = variantIdInput?.value;
    if (variantId && variantPrices[variantId] != null) {
      priceInCents = variantPrices[variantId];
    }
  }
  if (priceInCents == null) return;

  const memberPrice = Math.round((priceInCents * (100 - percent)) / 100);
  const freeLabel = window.theme?.strings?.free ?? 'Free';
  const formatted = memberPrice === 0 ? freeLabel : (window.theme?.formatMoney?.(memberPrice, window.theme?.moneyFormat) ?? (memberPrice / 100).toFixed(2));
  const originalFormatted = priceInCents === 0 ? freeLabel : (window.theme?.formatMoney?.(priceInCents, window.theme?.moneyFormat) ?? (priceInCents / 100).toFixed(2));

  const priceWrappers = container.querySelectorAll('[data-price-wrapper][data-member-discount-percent]');
  priceWrappers.forEach((wrap) => {
    const productPriceEl = wrap.querySelector('[data-product-price]');
    const comparePriceEl = wrap.querySelector('[data-compare-price]');
    if (productPriceEl) {
      productPriceEl.textContent = formatted;
      productPriceEl.classList.add('product__price--sale');
    }
    if (comparePriceEl && !wrap.closest('[data-add-to-cart]')) {
      comparePriceEl.textContent = originalFormatted;
      comparePriceEl.classList.remove('hidden');
      wrap.closest('.product__price__wrap')?.querySelector('[data-compare-text]')?.classList.remove('hidden');
    }
  });

  const btnPrice = container.querySelector('[data-add-to-cart] .btn__price');
  if (btnPrice) {
    btnPrice.innerHTML = `${formatted} <s class="product__price--strike">${originalFormatted}</s>`;
  }
}

document.addEventListener('theme:variant:change', (e) => {
  const variant = e.detail?.variant;
  if (!variant) return;
  applyMemberDiscountPDP(e.target, variant);
});

function runMemberDiscountAfterTheme() {
  const container = document.querySelector('[data-form-wrapper]');
  if (!container || !window.ByteMemberDiscount) return;
  applyMemberDiscountPDP(container, null);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(runMemberDiscountAfterTheme, 600);
    setTimeout(runMemberDiscountAfterTheme, 2000);
  });
} else {
  setTimeout(runMemberDiscountAfterTheme, 600);
  setTimeout(runMemberDiscountAfterTheme, 2000);
}